export default __webpack_public_path__ + "static/media/Error-404.daa1e3c6.svg";